<template>
  <p
    v-if="text != null"
    slot="text"
    v-html="text"
    :class="
      color_text + '--text ' + text_type + (justify ? ' justified-text' : '')
    "
  ></p>
</template>

<script>
export default {
  name: "CText",
  props: {
    text: {
      type: String,
      default: null
    },
    text_type: {
      type: String,
      default: "simple_text"
    },
    color_text: {
      type: String,
      default: "medium_grey"
    },
    justify: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    parsedText: null
  }),
  beforeMount() {
    var parser = new DOMParser();
    var span = document.createElement("span");
    span.innerHTML = parser.parseFromString(this.text, "text/html");
    this.parsedText = span;
    JSON.stringify;
  }
};
</script>

<style scoped>
p {
  margin-bottom: 0px !important;
}
</style>
